<template>
  <div>
    <b-alert v-model="showServerError" variant="danger" dismissible>{{serverError}}</b-alert>
    <b-alert
      class="font-weight-light"
      variant="info"
      show
    >Log in to automatically report your Outlook productivity data to Clockk.</b-alert>
    <b-row class="pt-1">
      <b-col>
        <p class="font-weight-bold">Email</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-input
          v-model="email"
          type="email"
          :state="emailIsValid"
          @blur="validateEmail()"
          aria-describedby="email-feedback"
          :disabled="disableForm"
        ></b-form-input>
        <b-form-invalid-feedback id="email-feedback">Enter valid email address</b-form-invalid-feedback>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p class="pt-1 font-weight-bold">Password</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-input
          v-model="password"
          type="password"
          :state="passwordIsValid"
          @blur="validatePassword()"
          aria-describedby="password-feedback"
          :disabled="disableForm"
          v-on:keyup.enter="submit()"
        ></b-form-input>
        <b-form-invalid-feedback id="password-feedback">Enter valid password</b-form-invalid-feedback>
      </b-col>
    </b-row>
    <b-row class="pt-2">
      <b-col>
        <b-button class="mt-2" variant="success" @click="submit()" :disabled="disableForm">Log In</b-button>
      </b-col>
    </b-row>
    <b-row class="pt-2">
      <b-col>
        <a href="https://app.clockk.com/forgot-password" target="_blank">Forgot password?</a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import jwtDecode from "jwt-decode";

export default {
  name: "SignIn",
  props: {},
  data() {
    return {
      email: "",
      emailIsValid: null,
      password: "",
      passwordIsValid: null,
      disableForm: false,
      showServerError: false,
      serverError: null
    };
  },
  methods: {
    validateEmail() {
      this.emailIsValid = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
        this.email
      );
    },
    validatePassword() {
      this.passwordIsValid = this.password.length > 0;
    },
    submit() {
      this.validateEmail();
      this.validatePassword();
      if (this.emailIsValid && this.passwordIsValid) {
        this.disableForm = true;
        axios
          .create({
            timeout: 5000,
            headers: { "content-type": "application/x-www-form-urlencoded" }
          })
          .post(
            "https://ca-central.api.clockk.com" +
              `/auth/token?grant_type=password&username=${encodeURIComponent(
                this.email
              )}&password=${encodeURIComponent(this.password)}`
          )
          .then(response => {
            console.log(response);
            let access_token = response.data.access_token;
            let jwt = jwtDecode(access_token);
            axios
              .create({
                timeout: 5000,
                headers: {
                  Accept: "application/vnd.api+json",
                  Authorization: `Bearer ${access_token}`
                }
              })
              .get(
                "https://ca-central.api.clockk.com" +
                  `/api/v1/users?filter%5Bsub%5D=${encodeURIComponent(jwt.sub)}`
              )
              .then(response => {
                let user = {
                  userEmail: response.data.data[0].attributes.email,
                  userName: `${response.data.data[0].attributes.first} ${response.data.data[0].attributes.last}`,
                  userAgentToken:
                    response.data.data[0].attributes["agent-token"]
                };
                this.$store.commit("setUser", user);
                if (!this.$store.state.running)
                  this.$store.commit("toggleRunning");
                this.$router.push("home");
              });
          })
          .catch(error => {
            console.log(error);
            this.disableForm = false;
            this.showServerError = true;
            try {
              this.serverError = error.response.data.error_description;
            } catch (error) {
              this.serverError =
                "An error ocurred. Make sure you have an internet connection.";
            }
          });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
